import LikeIcon from "@/components/Like/LikeIcon";
import DynamicAvatar from "@/components/MyAvatar/DynamicAvatar";
import { useMetaLikeAndComment } from "@/hooks/useMeta";
import { ISubscription } from "@/interfaces/bundle.interface";
import { modifyAvatarUrl } from "@/utils/avatar.util";
import { totalSanitize } from "@/utils/sanitize.util";
import { shortUUID } from "@/utils/string.util";
import { formatRelativeTime } from "@/utils/time.util";
import { IconButton } from "@material-ui/core";
import NotificationsActiveOutlinedIcon from "@material-ui/icons/NotificationsActiveOutlined";
import TextsmsOutlinedIcon from "@material-ui/icons/TextsmsOutlined";
import { Card, Tooltip, Typography } from "antd";
import { css } from "emotion";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import styles from "./styles.module.less";

const { Paragraph } = Typography;

interface IProps {
  sub: ISubscription;
  loading: boolean;
}

const SubscriptionCard: React.FC<IProps> = ({ sub, loading }) => {
  const router = useRouter();
  const { commentTimeCount } = useMetaLikeAndComment(sub.id);
  return (
    <Card
      loading={loading}
      className={styles.container}
      onClick={() =>
        router.push(
          "/bundle/subscription/[id]",
          `/bundle/subscription/${shortUUID(sub.id)}`
        )
      }
    >
      <Card.Meta
        avatar={
          <Tooltip title={sub.owner.username}>
            <DynamicAvatar
              src={modifyAvatarUrl(sub.owner.avatarUrl)}
              className={css`
                opacity: 0.9;
              `}
              size="large"
            />
          </Tooltip>
        }
        title={
          <Link
            href="/bundle/subscription/[id]"
            as={`/bundle/subscription/${shortUUID(sub.id)}`}
          >
            <a className={styles.href}>{sub?.name || sub.navi?.params?.term}</a>
          </Link>
        }
        description={
          <>
            {sub?.description && (
              <Paragraph ellipsis={{ rows: 1, expandable: true }}>
                {totalSanitize(sub?.description)}
              </Paragraph>
            )}
            <div className={styles.time}>
              {formatRelativeTime(sub.updated_at)}
            </div>
            <div className={styles.flex}>
              <LikeIcon
                fatherId={sub?.id}
                init={true}
                url={`/bundle/subscription/${shortUUID(sub.id)}`}
              />
              <IconButton>
                <TextsmsOutlinedIcon />
                <span className={styles.iconText}>{commentTimeCount}</span>
              </IconButton>
              {sub.subscribed && (
                <IconButton color="primary">
                  <NotificationsActiveOutlinedIcon />
                </IconButton>
              )}
            </div>
          </>
        }
      />
    </Card>
  );
};

export default SubscriptionCard;
